<!--
 * @Descripttion: 报表组件
 * @Author: zenghua.wang
 * @Date: 2021-04-28 09:30:58
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-04-24 12:20:51
-->
<template>
  <section
    :class="setClass()"
    :style="styleSize"
    v-loading="loading"
    :element-loading-text="component.loadingText"
  >
    <div
      :class="setClass('title')"
      v-if="option.title"
      :style="styleTitle"
    >{{option.title}}</div>

    <el-form
      v-if="isSearch && showSearch"
      :class="setClass('serch')"
      inline
      :size="option.size || config.option.size"
      @submit.native.prevent
      label-width="120px"
      label-suffix="："
    >
      <div :class="setClass('serch__input')">
        <report-filter
          :option="option"
          :params="params"
        />
      </div>

      <div
        :class="setClass('serch__action')"
        v-if="isSearch"
      >
        <el-button
          :size="option.size"
          type="primary"
          icon="el-icon-search"
          @click="onSearch"
        >
          查询
        </el-button>
        <el-button
          :size="option.size"
          icon="el-icon-delete"
          @click="onSearchClear"
        >
          清空
        </el-button>
      </div>
    </el-form>

    <!-- 操作 -->
    <div
      :class="setClass('menu')"
      v-if="barBtn || option.columnBtn"
    >
      <div class="xa-pull-left">
        <template v-for="(item,index) in option.buttons">
          <el-button
            :key="index"
            v-if="item.position==='header' && showDevice(item)"
            :size="option.size"
            :type="item.style"
            :icon="item.icon"
            @click="onAction(item)"
          >
            {{item.name}}
          </el-button>
        </template>
      </div>
      <div class="xa-pull-right">
        <el-tooltip
          v-if="option.columnBtn"
          effect="dark"
          content="显 隐"
          placement="top"
        >
          <el-button
            :size="option.size"
            icon="el-icon-s-operation"
            circle
            @click="onShowField"
          />
        </el-tooltip>
        <!-- <el-tooltip
            effect="dark"
            content="搜 索"
            placement="top"
          >
            <el-button
              :size="option.size"
              icon="el-icon-search"
              circle
              @click="onShowSearch"
            />
          </el-tooltip> -->
      </div>
    </div>

    <!-- 设计table -->
    <div
      :class="setClass('table')"
      v-if="option.column && option.column.length > 0"
    >
      <el-table
        tooltip-effect="dark"
        fit
        :key="id"
        :data="dataList"
        :size="option.size || config.option.size"
        :stripe="option.stripe"
        :border="option.border"
        :show-header="option.showHeader"
        :row-class-name="option.rowClassName || config.option.rowClassName"
        :default-sort="option.defaultSort || config.option.defaultSort"
        :header-cell-style="onSetHeadCellStyle"
        :span-method="setSpan"
        @selection-change="onSelectionChange"
      >
        <!-- 多选 -->
        <el-table-column
          v-if="option.selection"
          fixed
          type="selection"
          width="50"
          align="center"
        />

        <!-- index -->
        <el-table-column
          v-if="option.index"
          type="index"
          label="序号"
          width="50"
          align="center"
          :index="1"
        />

        <!-- 常规列 -->
        <template v-for="(item, index) in option.column">
          <report-column
            v-if="item.showType === 'show'"
            :key="index"
            :column="item"
            :config="config"
          />
        </template>

        <!-- 操作 -->
        <el-table-column
          v-if="rowBtn"
          label="操作"
          width="200"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <template v-for="(item,index) in option.buttons">
              <el-button
                :key="index"
                v-if="item.position==='row' && showDevice(item) && showButton(item, scope.row)"
                :size="option.size"
                :type="item.style"
                :icon="item.icon"
                @click.stop="onAction(item, scope)"
              >
                {{item.name}}
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 初始化数据 -->
    <div
      :class="setClass('table')"
      v-else
    >
      <report-mock
        :data="testList"
        :option="option"
        :headCellStyle='onSetHeadCellStyle'
      />
    </div>

    <!-- 分页 -->
    <div
      :class="setClass('page')"
      v-if="option.page"
    >
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
        :current-page="pageNum"
        :page-sizes="page.pageSizes"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
      />
    </div>

    <!-- 动态显示列 -->
    <el-drawer
      title="列显隐"
      :visible.sync="showField"
      size="50%"
      append-to-body
    >
      <el-transfer
        :class="setClass('transfer')"
        :titles="['显示', '隐藏']"
        :props="{
          label: 'label',
          key: 'prop'
        }"
        filterable
        v-model="fieldList"
        :data="option.column"
        @change="onSetField"
      ></el-transfer>
    </el-drawer>

    <!-- 编辑 -->
    <report-edit
      :show.sync="edit.show"
      :title="edit.title"
      :editable="edit.editable"
      :option="option"
      :row="edit.row"
    />

    <!-- 弹窗 -->
    <report-dialog
      :show.sync="dialog.show"
      :title="dialog.title"
      :option="dialog.option"
      :data="dialog.data"
      @change="onDialogMessage"
    />

    <!-- 导入 -->
    <report-import
      :show.sync="dimport.show"
      :title="dimport.title"
      :option="dimport.option"
      :data="dimport.data"
      @change="onImportRequest"
    />

  </section>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import { component, reportConfig } from '@/dragComponents/model/default.js'
import {
  deepClone,
  setPx,
  setRowByRoute,
  isEmpty,
  evalFunctionByFormatter,
  getQueryArrByParams,
  getTextByAnalysis,
  getShowButtonByExpression
} from '@/dragComponents/utils'
import mock from '@/dragComponents/model/mock.js'

import reportFilter from './fragment/filter.vue'
import reportColumn from './fragment/column.vue'
import reportMock from './fragment/mock.vue'
import reportEdit from './dialog/edit.vue'
import reportDialog from './dialog/dialog.vue'
import reportImport from './dialog/import.vue'

export default {
  name: 'drag-report',
  mixins: [bem],
  components: {
    reportFilter,
    reportColumn,
    reportMock,
    reportEdit,
    reportDialog,
    reportImport
  },
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    apiId: {
      type: [Number, String]
    },
    width: {
      type: [Number, String],
      default: '100%'
    },
    height: {
      type: [Number, String],
      default: '100%'
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    page: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      pageNum: 1,
      pageTotal: 0,
      params: [],
      conditions: [],
      dataList: [],
      showSearch: true,
      // 默认配置
      config: reportConfig,
      component: component,
      // 显隐列
      showField: false,
      fieldList: [],
      // 编辑
      edit: {
        title: '编辑',
        show: false,
        editable: true,
        row: null
      },
      // 弹窗
      dialog: {
        title: '',
        show: false,
        option: null,
        data: null
      },
      // 数据导入
      dimport: {
        title: '',
        show: false,
        option: null,
        data: null
      }
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: design.bg,
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width:
            this.category === 'report'
              ? this.width || '100%'
              : setPx(this.width),
          height:
            this.category === 'report'
              ? this.height || 'auto'
              : setPx(this.height)
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    styleTitle() {
      return {
        fontSize: setPx(this.option.titleFontSize),
        fontWeight: this.option.titleFontWeight,
        color: this.option.titleColor
      }
    },
    isSearch() {
      let len = this.option.column.filter((item) => {
        return item.search
      })
      return len.length > 0
    },
    rowBtn() {
      let list = this.option.buttons.filter((item) => {
        return item.position === 'row'
      })
      return !isEmpty(list)
    },
    barBtn() {
      let list = this.option.buttons.filter((item) => {
        return item.position === 'header'
      })
      return !isEmpty(list)
    }
  },
  watch: {
    apiId() {
      this.loadDataList()
    },
    'option.column'() {
      let list = deepClone(this.dataList)
      setTimeout(() => {
        this.dataList = list
        this.params = []
      }, 200)
    },
    'option.refresh'(val) {
      if (val) {
        this.loadDataList()
        this.loadDictory()
      }
    }
  },
  methods: {
    // 表头颜色设置
    onSetHeadCellStyle({ row, column, rowIndex, columnIndex }) {
      let color = '#333'
      this.option.column.forEach((item) => {
        if (item.label === column.label) {
          color = item.color
        }
      })
      if (rowIndex === 0) {
        return `color: ${color};background:#fafafa;font-weight:bold;font-size:13px;`
      }
    },
    // 获取data.list
    loadDataList(conditions = []) {
      if (!this.apiId) return
      this.conditions = conditions
      this.loading = true
      // 搜索条件
      let query = {}
      let restParams = []
      if (this.option.page) {
        query.pageNum = this.pageNum
        query.pageSize = this.page.pageSize
      }
      // 过滤条件
      (this.option.reqParams || []).map((item, index) => {
        // 外部条件、参数
        if (!isEmpty(item.key) && !isEmpty(this.$route.query[item.key])) {
          query[item.prop] = this.$route.query[item.key]
        }
        // 固定值、登录人等非空查询
        if (!isEmpty(item.value)) {
          query[item.prop] = item.value
        }
      })

      // 关联组件条件变化
      if (!isEmpty(this.conditions)) {
        this.conditions.forEach((item) => {
          this.option.reqParams.map((col) => {
            if (item.label === col.key && !isEmpty(item.value)) {
              query[col.prop] = item.value
            }
          })
        })
      }

      this.option.column.map((item, index) => {
        // 搜索参数赋值
        if (item.search && this.params[index]) {
          query[item.prop] = this.params[index]
        }
      })
      // console.log('loadDataList query==', query)

      this.$http({
        method: this.option.reqMethod,
        url: mock.getUrl(this.option.page) + this.apiId,
        data: restParams, // body
        params: query // query
      })
        .then((res) => {
          if (res.code === 200) {
            let dataList = this.option.page ? res.data.records : res.data
            let len = dataList.length
            // 特殊处理
            dataList.forEach((item) => {
              let selectMap = item.selectMap || {}
              if (!isEmpty(selectMap)) {
                if (selectMap.hasOwnProperty('$name')) {
                  item.name = selectMap.$name
                }
                if (selectMap.hasOwnProperty('$code')) {
                  item.code = selectMap.$code
                }
              }
            })
            // 未分页、在设计阶段取前10条
            if (!this.option.page && !this.disabled) {
              this.dataList = len > 10 ? dataList.slice(1, 10) : dataList
            } else {
              this.dataList = dataList
            }
            this.pageTotal = res.data.total || 0
          }
          this.loading = false
          this.option.refresh = false
        })
        .catch((err) => {
          this.loading = false
          this.option.refresh = false
          this.$message.error(err.msg)
        })
    },
    // 加载字典
    loadDictory() {
      if (!this.apiId) return
      let dicList = this.option.column.filter((item) => {
        return item.dicFrom === '动态' && item.dicUrl && item.dicMethod
      })
      if (isEmpty(dicList)) return
      dicList.forEach((item) => {
        this.$http({
          method: item.dicMethod,
          url: item.dicUrl,
          data: {},
          params: {}
        })
          .then((res) => {
            if (res.code === 200) {
              item.dicData = res.data
            }
          })
          .catch((err) => {
            this.$message.error(err.msg)
          })
      })
    },
    init() {
      // 外部参数值初始化
      let outerParams = getQueryArrByParams(this.$route.query)
      this.option.column.map((item, index) => {
        outerParams.forEach((op) => {
          if (op.label === item.prop) {
            this.params[index] = op.value
          }
        })
      })
      if (isEmpty(this.apiId)) {
        this.testList = mock.report.data
      } else {
        this.loadDataList()
        this.loadDictory()
      }
    },
    getColspan(column, conditions) {
      let rowList = this.dataList
      let len = rowList.length
      let arr = []
      for (var i = 0; i < len; i++) {
        let colspan = 1
        for (var j = i + 1; j < len; j++) {
          let bool = conditions.every((col) => {
            // return (
            //   !isEmpty(rowList[i][col]) &&
            //   !isEmpty(rowList[j][col]) &&
            //   rowList[i][col] === rowList[j][col]
            // )
            return rowList[i][col] === rowList[j][col]
          })
          if (
            bool &&
            // !isEmpty(rowList[i][column]) &&
            // !isEmpty(rowList[j][column]) &&
            rowList[i][column] === rowList[j][column]
          ) {
            colspan += 1
            arr[i] = colspan
            arr[j] = 0
            if (j === len - 1) i = j
          } else {
            colspan = 1
            if (!arr[i]) arr[i] = colspan
            i = j
            arr[j] = colspan
          }
        }
      }
      return arr
    },
    // 合并列
    setSpan({ row, column, rowIndex, columnIndex }) {
      let columnList = this.option.column.filter((item) => {
        return item.showType !== 'hide'
      })
      let rowList = this.dataList
      let conditions = []

      if (rowList.length <= 1) {
        return {
          rowspan: 1,
          colspan: 1
        }
      } else {
        for (let i = 0, columnLen = columnList.length; i < columnLen; i++) {
          if (columnList[i].isColspan) {
            let arr = this.getColspan(columnList[i].prop, conditions)
            let index = this.option.selection
              ? this.option.index
                ? i + 2
                : i + 1
              : this.option.index
                ? i + 1
                : i
            conditions.push(columnList[i].prop)
            if (columnIndex === index) {
              for (let j = 0, rowLen = rowList.length; j < rowLen; j++) {
                if (rowIndex === j) {
                  return {
                    rowspan: arr[j],
                    colspan: arr[j] > 0 ? 1 : 0
                  }
                }
              }
            }
          }
        }
      }
    },
    // 搜索
    onSearch() {
      this.pageNum = 1
      this.loadDataList(this.conditions)
    },
    // 搜索清除
    onSearchClear() {
      this.params = []
      this.onSearch()
    },
    onShowSearch() {
      this.showSearch = !this.showSearch
    },
    // 显隐列
    onShowField() {
      this.fieldList = []
      this.option.column.filter((item) => {
        if (item.showType !== 'show') {
          this.fieldList.push(item.prop)
        }
      })
      this.showField = true
    },
    onSetField(val, direction, key) {
      if (direction === 'left') {
        this.option.column.forEach((item) => {
          if (key.includes(item.prop)) {
            item.showType = 'show'
          }
        })
      } else {
        this.option.column.forEach((item) => {
          if (key.includes(item.prop)) {
            item.showType = 'hide'
          }
        })
      }
    },
    // 多选
    onSelectionChange() {},
    // page
    onSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.loadDataList(this.conditions)
    },
    onCurrentChange(current) {
      this.pageNum = current
      this.loadDataList(this.conditions)
    },
    // 按钮操作
    showButton(item, row) {
      row.device = this.device
      let show = getShowButtonByExpression(item.condition, row, this)
      if (typeof show === 'boolean') {
        return show
      } else {
        throw new Error(
          item.name + '按钮的显示条件表达式配置错误，请查看配置！'
        )
      }
    },
    showDevice(item) {
      // 设计
      if (!this.disabled) {
        return true
      }
      // 两端显示
      if (isEmpty(item?.device)) {
        return true
      } else {
        // 设备显示
        return item?.device === this.device
      }
    },
    onAction(opt, scope = {}) {
      // 将路由里面的参数添加到row里面，解析url
      let params = getQueryArrByParams(this.$route.query)
      scope.row = setRowByRoute(params, scope?.row)
      switch (opt.fun) {
        case 'openURL':
          this.setOpenURL(opt, scope)
          break
        case 'dialog':
          this.setOpenDialog(opt, scope)
          break
        case 'interface':
          this.setInterface(opt, scope?.row)
          break
        case 'import':
          this.setImportData(opt, scope)
          break
        case 'export':
          this.setExportData(opt, scope?.row)
          break
        case 'event':
          evalFunctionByFormatter(opt.formatter, scope?.row, this)
          break
      }
    },
    // 表头参数、行内参数转换
    convertParams(opt, row) {
      let params = {
        body: {},
        query: {}
      }
      if (opt.position === 'header') {
        row = {}
        this.option.column.map((item, index) => {
          if (item.search) {
            row[item.prop] = this.params[index] || ''
          }
        })
      }
      let list = !isEmpty(row) ? Object.keys(row) : []
      if (!isEmpty(opt.params)) {
        opt.params.forEach((el) => {
          if (isEmpty(el.type)) {
            params['query'][el.label] = list.includes(el.value)
              ? row[el.value]
              : el.value
          } else {
            params[el.type][el.label] = list.includes(el.value)
              ? row[el.value]
              : el.value
          }
        })
      }
      return params
    },
    // 新窗口打开
    setOpenURL(opt, scope) {
      if (isEmpty(opt.url)) {
        this.$message.error('跳转地址配置错误！')
        return
      }
      let url = getTextByAnalysis(opt.url, scope?.row, true)
      if (url.includes('http')) {
        window.open(url, '_blank')
      } else {
        this.$router.push(url)
      }
    },
    // 弹窗窗口
    setOpenDialog(opt, scope) {
      let title = getTextByAnalysis(
        opt.title,
        scope?.row,
        false,
        this.option.column
      )
      this.dialog.title = title || opt.name
      this.dialog.option = opt
      this.dialog.data = scope
      this.dialog.show = true
    },
    // apis接口
    setInterface(opt, row) {
      let params = this.convertParams(opt, row)
      opt.url = getTextByAnalysis(opt.url, row)
      if (isEmpty(opt.tips)) {
        this.onRequest(opt, params.body, params.query)
      } else {
        this.$confirm(opt.tips, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.onRequest(opt, params.body, params.query)
          })
          .catch((e) => {})
      }
    },
    // 数据导入
    setImportData(opt, scope) {
      this.dimport.title = opt.name
      this.dimport.option = opt
      this.dimport.data = scope
      this.dimport.show = true
    },
    // 数据导出
    setExportData(opt, row) {
      let params = this.convertParams(opt, row)
      let query = {}
      let condition = {}
      let column = []
      // 查询条件、选择字段、index
      this.option.column.map((item, index) => {
        if (item.search && this.params[index]) {
          condition[item.prop] = this.params[index]
        }
        if (item.showType === 'show') {
          column.push(item)
        }
      })
      // 关联条件 多选取值
      if (!isEmpty(this.conditions)) {
        this.conditions.forEach((item) => {
          this.option.reqParams.map((col) => {
            if (item.label === col.key && !isEmpty(item.value)) {
              condition[col.prop] = item.value
            }
          })
        })
      }
      query['_condition'] = condition
      query['_column'] = column
      query['_index'] = this.option.index
      query = Object.assign(query, params.body)
      // excel后缀
      if (!isEmpty(params.query?.fileName)) {
        params.query.fileName = params.query?.fileName + '.xlsx'
      }
      // console.log('export==', params, query)
      this.loading = true
      this.$downloadFile({
        method: opt.reqMethod || 'GET',
        url: opt.url,
        data: query,
        params: params.query
      })
        .then((res) => {
          this.$message.success(res.msg)
          this.loading = false
        })
        .catch((err) => {
          this.$message.error(err.msg)
          this.loading = false
        })
    },
    // 数据导入请求
    onImportRequest(form, opt, scope) {
      let params = this.convertParams(opt, scope?.row)
      let formData = new window.FormData()
      if (form.file) {
        formData.append('file', form.file)
      }
      if (!isEmpty(params.body)) {
        for (var key in params.body) {
          formData.append(key, params.body[key])
        }
      }
      if (isEmpty(opt.reqMethod)) {
        opt.reqMethod = 'POST'
      }
      this.onRequest(opt, formData, params.query, true)
    },
    // apis请求
    onRequest(opt, body = {}, query = {}, isFile = false) {
      let httpOption = {
        method: opt.reqMethod,
        url: opt.url,
        data: body,
        params: query
      }
      if (isFile) {
        httpOption.headers = { 'Content-Type': 'multipart/form-data' }
      }
      this.$http(httpOption)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(res.msg)
            this.loadDataList()
          }
        })
        .catch((err) => {
          this.$message.error(err.msg)
        })
    },
    // dialog、iframe通信
    onDialogMessage(msg) {
      if (msg === 'freshList') {
        this.loadDataList()
        this.loadDictory()
      }
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/report/index.scss';
</style>
